// Analytics utility for Umami tracking
// Only tracks events in production environment

const isProduction = () => {
  // Check if running in production based on hostname
  const hostname = window.location.hostname;
  return hostname === 'collectedwit.com' || hostname === 'www.collectedwit.com';
};

const isTrackingDisabled = () => {
  return localStorage.getItem('disable-tracking') === 'true';
};

/**
 * Track a custom event in Umami
 * @param {string} eventName - Name of the event (will be namespaced)
 * @param {object} eventData - Optional event data/properties
 */
export const trackEvent = (eventName, eventData = {}) => {
  // Check if tracking is disabled
  if (isTrackingDisabled()) {
    console.log('[Analytics - Tracking Disabled]', eventName, eventData);
    return;
  }

  if (!isProduction()) {
    console.log('[Analytics - Dev Mode]', eventName, eventData);
    return;
  }

  // Check if umami is available
  if (window.umami) {
    window.umami.track(eventName, eventData);
  }
};

/**
 * Track riddle game events
 */
export const trackRiddleGame = {
  /**
   * Track game start
   * @param {string} gameMode - 'easy' or 'blitz'
   */
  start: (gameMode) => {
    trackEvent('nitwit-blitz-start', { mode: gameMode });
  },

  /**
   * Track riddle answer submission
   * @param {boolean} isCorrect - Whether answer was correct
   * @param {string} difficulty - Riddle difficulty (easy/medium/hard)
   * @param {number} timeRemaining - Seconds remaining when answered
   */
  answerRiddle: (isCorrect, difficulty, timeRemaining) => {
    trackEvent('nitwit-blitz-answer', {
      correct: isCorrect,
      difficulty,
      timeRemaining
    });
  },

  /**
   * Track riddle pass
   */
  pass: () => {
    trackEvent('nitwit-blitz-pass');
  },

  /**
   * Track game completion
   * @param {object} stats - Game statistics
   */
  complete: (stats) => {
    trackEvent('nitwit-blitz-complete', {
      score: stats.score,
      riddlesSolved: stats.riddlesSolved,
      mode: stats.gameMode,
      duration: stats.duration
    });
  },

  /**
   * Track game end (manual quit)
   * @param {number} score - Final score
   * @param {number} riddlesSolved - Number of riddles solved
   */
  end: (score, riddlesSolved) => {
    trackEvent('nitwit-blitz-end', {
      score,
      riddlesSolved
    });
  }
};
